import * as React from 'react'

import { useMutation } from 'react-query'

interface DownloadButtonProps {
  jobnumber: {
    id: number
  }
  downloadAttachments: (params: { jobnumber_id: number }) => Promise<{ message: string }>
}

export default function DownloadButton({ jobnumber, downloadAttachments }) {
  const mutation = useMutation(jobnumberId => downloadAttachments({ jobnumber_id: jobnumberId }), {
    onSuccess: async (d: any) => {
      alert(d.message)
    },
  })

  return (
    <button
      type="button"
      disabled={mutation.isLoading}
      className="btn btn-outline-secondary px-5"
      onClick={() => mutation.mutate(jobnumber.id)}
    >
      {mutation.isLoading ? <i className="fa fa-spinner fa-spin" /> : 'Download alt'}
    </button>
  )
}
